<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="guia-de-estilo-2021" stroke="none" stroke-width="1" :fill="color" fill-rule="nonzero">
      <g
        id="06-Iconos-"
        transform="translate(-1002.000000, -610.000000)"
        :fill="color"
        fill-rule="nonzero"
      >
        <g id="Group-4" transform="translate(142.000000, 610.000000)">
          <g id="Icon/icn_chevrons-right" transform="translate(860.000000, 0.000000)">
            <path
              d="M16.3905243,8.39052429 C16.9112233,7.86982524 17.7554433,7.86982524 18.2761424,8.39052429 L18.2761424,8.39052429 L24.942809,15.057191 C25.4635081,15.57789 25.4635081,16.42211 24.942809,16.942809 L24.942809,16.942809 L18.2761424,23.6094757 C17.7554433,24.1301748 16.9112233,24.1301748 16.3905243,23.6094757 C15.8698252,23.0887767 15.8698252,22.2445567 16.3905243,21.7238576 L16.3905243,21.7238576 L22.1143819,16 L16.3905243,10.2761424 C15.8698252,9.75544332 15.8698252,8.91122335 16.3905243,8.39052429 Z M7.05719096,8.39052429 C7.57789001,7.86982524 8.42210999,7.86982524 8.94280904,8.39052429 L8.94280904,8.39052429 L15.6094757,15.057191 C16.1301748,15.57789 16.1301748,16.42211 15.6094757,16.942809 L15.6094757,16.942809 L8.94280904,23.6094757 C8.42210999,24.1301748 7.57789001,24.1301748 7.05719096,23.6094757 C6.5364919,23.0887767 6.5364919,22.2445567 7.05719096,21.7238576 L7.05719096,21.7238576 L12.7810486,16 L7.05719096,10.2761424 C6.5364919,9.75544332 6.5364919,8.91122335 7.05719096,8.39052429 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconChevronsRight extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconChevronsRight;
</script>
